import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import SideNavLayout from "../Sidenav/SideNavLayout";
import api from "../api/api";

const Logs = () => {
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [logType, setLogType] = useState("OTP_LOGS");
  const [logsData, setLogsData] = useState([]);

  const fetchData = async () => {
    try {
      setLoader(true);
      const response = await api.get("/v1/admin-user/otp/logs");

      if (response?.status === 200) {
        setLogsData(response.data || []);
      } else {
        setLogsData([]);
      }
    } catch (error) {
      console.error("Failed to fetch logs:", error);
      setLogsData([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const filteredLogs = logsData.filter((log) =>
    log.mobilephone?.includes(searchText)
  );

  return (
    <SideNavLayout>
      {/* Loader */}
      {loader && (
        <div className="fixed inset-0 bg-white/70 flex justify-center items-center z-[9999]">
          <CircularProgress size={60} />
        </div>
      )}

      <div className="p-6">
        <h1 className="text-2xl text-start font-semibold text-[#1d2951] mb-6">
          Application Logs
        </h1>

        {/* Filters */}
        <div className="flex flex-wrap gap-4 justify-between items-center p-3 border-b">
          <select
            value={logType}
            onChange={(e) => setLogType(e.target.value)}
            className="border border-gray-300 px-4 py-2 rounded-lg text-sm"
          >
            <option value="OTP_LOGS">OTP Logs</option>
          </select>

          <input
            type="text"
            placeholder="Search by mobile number"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            className="border border-gray-300 px-4 py-2 rounded-lg text-sm w-64"
          />
        </div>

        {/* Table Card */}
        <div className="bg-white rounded-xl shadow-sm border mt-4">
          {/* 👇 Scroll Wrapper */}
          <div className="max-h-[420px] overflow-y-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-50 text-center text-gray-600 uppercase text-xs sticky top-0 z-10">
                <tr>
                  <th className="px-6 py-3">S/N</th>
                  <th className="px-6 py-3">Mobile Number</th>
                   <th className="px-6 py-3 text-center">Device Id</th>
                    <th className="px-6 py-3 text-center">Device UID</th>
                  <th className="px-6 py-3">OTP</th>
                  <th className="px-6 py-3">Timestamp</th>
                </tr>
              </thead>

              <tbody>
                {filteredLogs.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="px-6 py-10 text-center text-gray-500">
                      No logs found.
                    </td>
                  </tr>
                ) : (
                  filteredLogs.map((log, index) => (
                    <tr key={log.id} className="border-t  text-center">
                      <td className="px-6 py-4">{index + 1}</td>
                      <td className="px-6 py-4">
                        +{log.countrycode} {log.mobilephone}
                      </td>
                           <td className="px-6 py-4 text-center font-mono">{log?.device_id||'-'}</td>
                                 <td className="px-6 py-4 text-center font-mono">{log?.device_name||'-'}</td>
                      <td className="px-6 py-4 font-mono">{log.otp}</td>
                      <td className="px-6 py-4 text-gray-600">
                        {log.created_on}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </SideNavLayout>
  );
};

export default Logs;
